/* @flow */

import setEventoEntrar from './set-evento-entrar';
import setEventoEsqueciMinhaSenha from './set-evento-esqueci-minha-senha';
import getElementoPorId from '../utils/get-elemento-por-id';
import { deleteState } from '../preact-app/local-storage';

deleteState();
setEventoEntrar(getElementoPorId('form-login'));
setEventoEsqueciMinhaSenha();
